import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "display"
    }}>{`display`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{`  UXP v3.0`}</p>
    <p>{`Determines the layout semantics for the element. Supports `}<inlineCode parentName="p">{`none`}</inlineCode>{`, `}<inlineCode parentName="p">{`inline`}</inlineCode>{`, `}<inlineCode parentName="p">{`block`}</inlineCode>{`, `}<inlineCode parentName="p">{`inline-block`}</inlineCode>{`, `}<inlineCode parentName="p">{`flex`}</inlineCode>{`, and `}<inlineCode parentName="p">{`inline-flex`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/CSS/display"
      }}>{`https://developer.mozilla.org/en/docs/Web/CSS/display`}</a></p>
    <p><strong parentName="p">{`Example`}</strong>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.someElement {
    display: flex;
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      